import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";

function Graph({ log_data, key_list, legend_enabled }) {
    const chartRef = useRef(null);
    const chartInstanceRef = useRef(null);
    
    // Process data
    let keys = [];
    let dataset = [];
    let validDataset = [];
    let times = [];
    let borderColor = {};
    
    if (log_data && Array.isArray(log_data) && log_data.length > 0 && 
        key_list && Array.isArray(key_list) && key_list.length > 0) {
        
        keys = [...key_list];
        dataset = [...log_data];
        
        // Filter out invalid data objects
        validDataset = dataset.filter(obj => obj && obj.time && typeof obj.time === 'string');
        const index = keys.indexOf("time");
        if (index !== -1) {
            keys.splice(index, 1);
        }
        
        // Safe time extraction with error handling
        times = validDataset.map((obj) => {
            try {
                return obj.time.split(" ")[1].split(":").slice(0, 2).join(":");
            } catch (error) {
                console.warn('Invalid time format:', obj.time);
                return '00:00';
            }
        });
        
        const color_list = [
            "#36a2eb", "#e74c3c", "#2ecc71", "#ff9f40", "#ff6384",
            "#ffcd56", "#4bc0c0", "#9966ff", "#3498db", "#ffd700",
        ];
        
        keys.forEach((key, index) => {
            borderColor[key] = color_list[index % color_list.length];
        });
    }

    useEffect(() => {
        if (!validDataset.length || !keys.length) {
            return;
        }
        
        if (chartInstanceRef.current) {
            chartInstanceRef.current.destroy();
        }

        const ctx = chartRef.current.getContext("2d");
        const datasets = keys.map((label) => ({
            label,
            data: validDataset.map((obj) => obj[label] || 0),
            borderColor: borderColor[label],
            borderWidth: 1.5,
            fill: false,
            pointStyle: false,
        }));

        const chart = new Chart(ctx, {
            type: "line",
            data: { labels: times, datasets },
            options: {
                plugins: {
                    legend: {
                        display: legend_enabled,
                        labels: {
                            usePointStyle: true,
                            pointStyle: "rectRounded",
                            generateLabels: function (chart) {
                                const labels = Chart.defaults.plugins.legend.labels.generateLabels(chart);
                                labels.forEach((label) => {
                                    label.fillStyle = borderColor[label.text];
                                });
                                return labels;
                            },
                        },
                    },
                },
                scales: {
                    x: {
                        display: true,
                        title: {
                            display: true,
                            text: "Time",
                        },
                    },
                    y: {
                        display: true,
                        title: {
                            display: true,
                            text: "Value",
                        },
                    },
                },
                responsive: true,
                maintainAspectRatio: false,
            },
        });

        chartInstanceRef.current = chart;

        return () => {
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
            }
        };
    }, [validDataset, keys, legend_enabled]);

    // Safety checks for data - after hooks
    if (!log_data || !Array.isArray(log_data) || log_data.length === 0) {
        return <div className="text-center p-4 text-muted">No data available for chart</div>;
    }
    if (!key_list || !Array.isArray(key_list) || key_list.length === 0) {
        return <div className="text-center p-4 text-muted">No keys available for chart</div>;
    }

    return <canvas ref={chartRef}></canvas>;
}

export default Graph;